import * as React from "react";
import { useRouteMatch } from "react-router-dom";
import { ILimitsRouteParams } from "../../../types/components/limits/limitsTypes";
import LimitsHeader from "../generic/limitsHeader";
import LimitsLeftCol from "../generic/limitsLeftCol";
import LimitsRightCol from "../generic/limitsRightCol";
import Tab from "../../../generic/tab";
import Loader from "../../../generic/loader";
import { IListObj } from "../../../types/genericTypes";
import "../../../../assets/scss/components/toc/limits/limitsDsk.scss";
import "../../../../assets/scss/components/toc/limits/limitsMob.scss";
import NoDataContainer from "../../../generic/noDataContainer";

export interface ILimitsLayoutMobProps {
	limitsData: any;
	secNavOptions: Array<IListObj>;
	showLoader: boolean;
	tryAgain: () => void;
}

const LimitsLayoutMob: React.FC<ILimitsLayoutMobProps> = (props) => {
	const routeParams = useRouteMatch<ILimitsRouteParams>();

	return (
		<section className="outer_container container_mob limits">
			<section className="lyCont">
				<section className="ob_pos_mob">
					<div className="limits_hdr">
						<Tab defaultValue={routeParams.params.asset || "equity"} tabList={props.secNavOptions} position="center" />
					</div>
					{/* If there is header in limitsdata, then we have got api response, otherwise it is still loading */}
					{props.showLoader ? (
						<div className="limits_loader_cont">
							<Loader size={20} color="blue" />
						</div>
					) : props.limitsData.header ? (
						<div className="ob_content_mob">
							<div className="taCenter available_limits">
								<LimitsHeader
									label="Available Limits"
									value={props.limitsData.header?.availableLimits}
									cshAvl={props.limitsData.header?.cshAvl}
									showAddWithdrawBtn
								/>
							</div>

							<div className="thick_divider" />

							<div className="limits_left_col">
								<LimitsLeftCol {...props.limitsData.leftCol} />
							</div>

							<div className="taCenter utilised_limits">
								<LimitsHeader label="Utilised Limits" value={props.limitsData.header?.utilizedLimits} />
							</div>

							<div className="thick_divider" />

							<div className="limits_right_col">
								<LimitsRightCol {...props.limitsData.rightCol} />
							</div>
						</div>
					) : (
						<NoDataContainer txtHeading="Something Went Wrong" linkDet={{ txt: "Try Again", type: "btn", clickHandler: props.tryAgain }} />
					)}
				</section>
			</section>
		</section>
	);
};

export default LimitsLayoutMob;
